import React from 'react';
import { BookOpen, Brain, Clock, Heart } from 'lucide-react';

const features = [
  {
    icon: BookOpen,
    title: (
      <span>
        <span className="text-accent text-2xl font-bold">P</span>lanejamento Textual
      </span>
    ),
    description: 'Estratégias personalizadas para organização e estruturação de ideias.',
  },
  {
    icon: Brain,
    title: (
      <span>
        <span className="text-accent text-2xl font-bold">D</span>omínio de Conhecimento
      </span>
    ),
    description: 'Desenvolvimento progressivo do repertório sociocultural.',
  },
  {
    icon: Clock,
    title: (
      <span>
        <span className="text-accent text-2xl font-bold">T</span>empo Otimizado
      </span>
    ),
    description: 'Técnicas eficientes para gerenciamento do tempo durante a prova.',
  },
  {
    icon: Heart,
    title: (
      <span>
        <span className="text-accent text-2xl font-bold">E</span>quilíbrio Emocional
      </span>
    ),
    description: 'Suporte para controle da ansiedade e autoconfiança.',
  },
];

const About = () => {
  return (
    <section id="about" className="py-12 md:py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary mb-4">
            Sobre o Método PDTE
          </h2>
          <p className="text-base md:text-xl text-primary/80 max-w-3xl mx-auto">
            Criado especialmente para desbloquear o potencial de alunos com TDAH, Dislexia e Autismo,
            nosso método revoluciona a forma de ensinar redação.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={typeof feature.title === 'string' ? feature.title : feature.description}
              className="p-6 bg-secondary-light rounded-xl shadow-lg hover:shadow-xl transition-shadow border-2 border-primary/20 hover:border-primary"
            >
              <feature.icon className="h-10 md:h-12 w-10 md:w-12 text-accent mb-4" />
              <h3 className="text-lg md:text-xl font-semibold text-primary mb-2">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-primary/80">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-12">
          <a
            href="#plans"
            className="inline-block px-6 md:px-8 py-3 md:py-4 bg-accent text-white rounded-full text-base md:text-lg font-semibold hover:bg-accent-dark transition-colors"
          >
            Descubra como o PDTE pode transformar seu desempenho
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;